import { useMemo, useState, type MouseEvent } from "react";
import { ChevronLeft } from "lucide-react";
import { filtraPerAmministratore, useElenco } from "./useElenco";
import { CampoCerca, ListaPreventivi } from "./ListaPreventivi";
import { bolletteRicevute, raggiuntoMassimo } from "./scritte";
import { FOCUS } from "./parti";
import { INDIETRO, IN_QUALE, TITOLO_LISTA } from "./scritteLista";

/** Il tetto di bollette per preventivo (Alfonso 25/10); la lista non lo riceve dal server, la pagina del preventivo sì. */
export const MASSIMO_BOLLETTE = 40;

interface Props {
  /** Quante bollette sono arrivate. */
  n: number;
  /** L'ultimo preventivo ha già il suo tasto: qui non compare. */
  escludi?: string;
  /** Dove porta una riga scelta. */
  href: (id: string) => string;
  onIndietro: () => void;
  /** Un tocco su una riga attiva, prima della navigazione. */
  onApri?: (e: MouseEvent<HTMLAnchorElement>) => void;
}

/** «In quale preventivo?» (mockup parte 5): la stessa lista e la stessa ricerca della pagina principale, solo schede.
 *  Un tocco su un nome porta lì; i preventivi già al massimo di bollette sono spenti con la frase del massimo. */
export function SceltaPreventivo({ n, escludi, href, onIndietro, onApri }: Props) {
  const [testo, setTesto] = useState("");
  const q = testo.trim();
  const { voci, errore, riprova } = useElenco();
  const altri = useMemo(
    () => (voci === null ? null : filtraPerAmministratore(voci, q).filter((v) => v.id !== escludi)),
    [voci, q, escludi],
  );
  return (
    <div className="mx-auto flex w-full max-w-lg flex-col gap-4">
      <h1 className="sr-only">{TITOLO_LISTA}</h1>
      <button
        type="button"
        onClick={onIndietro}
        className={`-ml-1 inline-flex h-11 w-fit items-center gap-1 rounded-lg px-1 text-sm font-medium text-brand-dark touch-manipulation cursor-pointer hover:text-brand ${FOCUS}`}
      >
        <ChevronLeft size={18} aria-hidden="true" />
        {INDIETRO}
      </button>
      <div>
        <p className="text-sm text-muted-foreground">{bolletteRicevute(n)}</p>
        <h2 className="text-xl font-semibold text-text">{IN_QUALE}</h2>
      </div>
      <CampoCerca valore={testo} onCambia={setTesto} />
      <ListaPreventivi
        voci={altri}
        q={q}
        errore={errore}
        onRiprova={riprova}
        href={(v) => href(v.id)}
        spenta={(v) => (v.bollette >= MASSIMO_BOLLETTE ? raggiuntoMassimo(MASSIMO_BOLLETTE) : undefined)}
        onApri={onApri}
        schede
      />
    </div>
  );
}
